import { Component } from '@angular/core'

import { AuditLogsComponent } from '@ti/shared/audit/components'
import { AuditLogGridDataResolver } from '@ti/shared/audit/services'

import env from '../../../../env'
import { AdminAuditLogGridDataResolver } from '../../services/grid-data.resolver'

@Component({
  selector: 'app-audit-wrapper',
  templateUrl: 'audit-wrapper.component.html',
  styleUrls: ['audit-wrapper.component.scss'],
  providers: [{ provide: AuditLogGridDataResolver, useClass: AdminAuditLogGridDataResolver }],
  imports: [AuditLogsComponent],
})
export class AdminAuditWrapperComponent {
  protected readonly isProduction = env.envType === 'production'
}
